import { ApplicationElement, html } from '@beunity/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';
import translations from './translations.js';
import style from './style.lit.css';
import '@beunity/lit-components/components/icon_block/element.js';
import '@beunity/lit-components/components/avatar/element.js';

/**
 * Unit component
 *
 * @prop name - Unit title ( string )
 * @prop href - Link to unit ( string )
 * @prop type - Unit type (options: open, closed, private)
 * @prop count - Unit members count ( number )
 * @prop picture - Unit picture ( string, optional )
 * @prop icon - Unit avatar ( string, optional )
 * @prop slot - name="menu"
 */
export default class UnitBig extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];
  /** @internal */
  static translations = translations;

  static properties = {
    name: { type: String },
    href: { type: String },
    type: { type: String },
    count: { type: Number },
    picture: { type: String },
    icon: { type: String },
  };

  typeIcons = {
    open: 'lock-open-alt', // open
    closed: 'lock-alt', // closed
    private: 'user-lock', // private
  };

  typeNames = {
    open: this.t('types.open'),
    closed: this.t('types.closed'),
    private: this.t('types.private'),
  };

  get typeIcon() {
    return this.typeIcons[`${this.type}`];
  }

  get typeName() {
    return this.typeNames[`${this.type}`];
  }

  renderPlaceholder() {
    return html` <div class="picture-placeholder"></div> `;
  }

  renderImage() {
    return html` <img src=${this.picture} /> `;
  }

  renderInfo() {
    return html`
      <div class="info">
        <ef-icon-block
          icon="${this.typeIcon}"
          text="${this.typeName}"></ef-icon-block>
        <ef-icon-block icon="user-friends" text="${this.count}"></ef-icon-block>
      </div>
    `;
  }

  render() {
    return html`
      <a href="${this.href}">
        <header>
          ${this.picture ? this.renderImage() : this.renderPlaceholder()}
          <ef-avatar
            picture=${ifDefined(this.icon)}
            name="${this.name}"></ef-avatar>
        </header>
        <main>
          <div class="title">${this.name}</div>
          ${this.renderInfo()}
        </main>
      </a>
      <slot name="menu"></slot>
    `;
  }
}

UnitBig.registerTagName('bu-unit-big');

customElements.get('bu-unit-big') ||
  customElements.define('bu-unit-big', UnitBig);
